import '@smastrom/react-rating/style.css';

import {
  Select,
  SelectItem,
} from '@heroui/react';
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useAuthState } from 'src/state';

import { ResponseSelectDataProps, useGetAdminUsers } from '../../../../queries';
import {
  AccountManagerFirestoreResponse,
  UpdateOrganizationAccountManagerRequest,
} from '../../../../types';
import { OrganizationEntity, organizationFormOptions } from './CreateAcountManagerForm.schema';

interface CreateAcountManagerFormProps {
    onSubmit: (e: UpdateOrganizationAccountManagerRequest) => void;
    initialValue?: AccountManagerFirestoreResponse | null;
}

export const CreateAcountManagerForm: FC<CreateAcountManagerFormProps> = ({
  onSubmit, initialValue,
}) => {
  const { currentUser } = useAuthState();
  const organizationsData = useGetAdminUsers();
  const { data: admins, isLoading } = organizationsData;
  const {
    formState, register, handleSubmit,
  } = useForm<OrganizationEntity>({
    ...organizationFormOptions,
    defaultValues: {
      account_manager: initialValue?.account_manager || '',
    },
  });

  return (
    <form
      data-testid="edit-account-manager-form"
      noValidate
      id="edit-account-manager-form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Select
        isRequired
        label="Select manager"
        size="lg"
        variant="bordered"
        radius="sm"
        isLoading={isLoading}
        defaultSelectedKeys={[initialValue?.account_manager ? initialValue?.account_manager : currentUser?.uid || '']}
        {...register('account_manager')}
        labelPlacement="outside"
        placeholder="Select manager"
        isInvalid={!!formState.errors.account_manager?.message}
        errorMessage={formState.errors.account_manager?.message}
      >
        {(admins ?? []).length > 0 ? (
          (admins ?? []).map((type: ResponseSelectDataProps) => (
            <SelectItem key={type.label} textValue={type.key}>
              {type.key}
            </SelectItem>
          ))
        ) : (
          <SelectItem key="none" textValue="No employees available">
            No employees available
          </SelectItem>
        )}
      </Select>
    </form>
  );
};
